<template>
  <div class="container vld-parent">
    <button-container v-on:conflict="showUnsavedWarning" />
    <loading :active="showLoading" :is-full-page="false"></loading>
    <filter-toolbar v-on:customer-tags="showTagsModal" />
    <div id="templates">
      <div id="empty-state" v-if="!templatesAvailable">
        <img src="../assets/empty_state.svg"/>
        <div>
          <h2>{{ $t('libraries.empty_library_heading') }}</h2>
          <p>{{ $t('libraries.empty_library_first_line') }}</p>
          <p>{{ $t('libraries.empty_library_second_line') }}</p>
        </div>
      </div>
      <div v-for="t in templates"   :key="t.id">
        <Template :template="t" :read-only="activeLibrary.readOnly" 
          v-on:unsaved-work="showUnsavedWarning"
          v-on:delete-template="showDeleteModal"
          v-on:rename-template="showRenameModal"
          v-on:duplicate-template="showDuplicateModal"
          v-on:share-template="showShareModal"
          v-on:merge-tags="showMergeTagsModal"
          v-on:download-unsaved-work="showDownloadModal"
          v-on:template-tags="showTemplateTagsModal" />
      </div>
    </div>
    <Pagination :page-count="pageCount" />
    <modal-container ref="modalContainer" />
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import Template from './Template.vue';
import Pagination from './Pagination';
import ModalContainer from './ModalContainer.vue';
import ButtonContainer from './ButtonContainer.vue';
import FilterToolbar from './FilterToolbar.vue';
import Loading from 'vue-loading-overlay';

export default {
  name: 'TemplateContainer',
  components: {
    Template,
    Pagination,
    ModalContainer,
    Loading,
    ButtonContainer,
    FilterToolbar
  },
  computed: {
    ...mapState({
      templates: state => state.templates,
      showLoading: state => state.loadingTemplates || state.loadingTemplate
    }),
    ...mapGetters([
      'activeLibrary'
    ]),
    templatesAvailable: function() {
      return this.templates && this.templates.length > 0;
    }
  },
  props: {
    pageCount: Number
  },
  methods: {
    ...mapMutations([
      'setTemplateName',
      'setTemplateId'
    ]),
    showUnsavedWarning: function(template) {
      this.$refs.modalContainer.unsavedWarning(template);
    },
    showDeleteModal: function(template) {
      this.$refs.modalContainer.openDeleteModal(template);
    },
    showRenameModal: function(template) {
      this.$refs.modalContainer.onRenameTemplate(template);
    },
    showDuplicateModal: function(template) {
      this.$refs.modalContainer.duplicateModal(template);
    },
    showShareModal: function(template) {
      this.$refs.modalContainer.shareModal(template);
    },
    showMergeTagsModal: function(template) {
      this.$refs.modalContainer.mergeTagsModal(template);
    },
    showDownloadModal: function(template) {
      this.$refs.modalContainer.downloadTemplate(template);
    },
    showTagsModal: function() {
      this.$refs.modalContainer.tagsModal();
    },
    showTemplateTagsModal: function(templateId) {
      this.$refs.modalContainer.templateTagsModal(templateId);
    }
  }
};
</script>

<style scoped>
  .container {
    padding-right: 0;
    padding-left: 0;
    width: 100%;
  }
  #templates {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 1em;
  }
  #empty-state {
    grid-column-start: 1;
    grid-column-end: 5;
  }
  #empty-state img {
    margin-top: 5em;
    margin-bottom: 3em;
    width: 35em;
  }
  #empty-state div * {
    color: #666;
    margin: 0;
  }
</style>
